module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.checkExpire(_vm.expired)) ? _c('div', {
    staticClass: "alert alert-danger text-center",
    staticStyle: {
      "margin-bottom": "60px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "900"
    }
  }, [_vm._v("\n        THIS FUNDING OPPORTUNITY HAS EXPIRED\n      ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d28b0e30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckExpiration.vue
// module id = 397
// module chunks = 0